const HTTP_LOCKED = 423;

export function reloadIfLocked(response) {
  if (response.status !== HTTP_LOCKED) return false;

  window.location.reload();
  return true;
}
